import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { MarginCalculatorDto, MarginReq } from "src/app/models/margin-calculator";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-margin-calculator",
  templateUrl: "./margin-calculator.component.html",
  styleUrls: ["./margin-calculator.component.scss"],
})
export class MarginCalculatorComponent implements OnInit {
  marginCalculator: MarginCalculatorDto = {} as MarginCalculatorDto;
  marginObj: any;
  chart: any;

  circleColor :string;

  marginReq: MarginReq = {} as MarginReq;
  public tabIndex = 0;
  relationCode: string;
  requiredBuy = 50;
  requiredSell = 50;
  textCircle :number;
  statusDetctor: any
  isDarkTheme: boolean;
  marginPercentage :number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    public translate: TranslateService,
    private dialog: MatDialog,
    private apiService: ApiService
  ) {
    if (this.data["relationCode"] != null) {
      this.relationCode = this.data["relationCode"];
    }
  }

  ngOnInit(): void {
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;
    this.apiService
      .fetchClientsCashPosition(this.relationCode)
      .subscribe((res: MarginCalculatorDto) => {
        this.marginCalculator = res;
        // this.marginPercentage =Math.abs((this.marginCalculator.marginCalculator.MarginBalance /this.marginCalculator.ClientPortfolio)*100)
        this.marginPercentage = this.marginCalculator.marginCalculator.DebtPer;    

        this.statusDetctor = this.marginPercentage;
        if(this.statusDetctor < 50){
          this.circleColor = '#2E94D3';
          this.textCircle = 1;
        }
        if(this.statusDetctor >= 50 && this.statusDetctor < 61){
          this.circleColor = '#28A745'
          this.textCircle = 2;
        }
        if(this.statusDetctor > 60 && this.statusDetctor < 70){
          this.circleColor = '#2eced3'
          this.textCircle = 3;
        }
        if(this.statusDetctor >= 70){
          this.circleColor = '#d33e2e'
          this.textCircle = 4;
        }
      });

    this.calculateSell();

  }

  resetCalculator() {
    this.requiredBuy = 50;
    this.requiredSell = 50;
  }

  calculateBuy(){
    this.marginReq.RelationCode = this.relationCode;
    this.marginReq.buy = this.requiredBuy;

    this.apiService
    .marginCalculator(this.marginReq)
    .subscribe((res) => {
      this.marginObj = res;
    });
  }
  calculateSell(){
    this.marginReq.RelationCode = this.relationCode;
    this.marginReq.sell = this.requiredSell;

    this.apiService
    .marginCalculator(this.marginReq)
    .subscribe((res) => {
      this.marginObj = res;
    });
  }
}
